export const generateValidURL = (linkRedirect: string): string => {
  if(linkRedirect.startsWith('http://') || linkRedirect.startsWith('https://')) {
    return linkRedirect
  }
  return `https://${linkRedirect}`
}
